import { Project, TextAnalyticsPlusDexie } from "../../../lib/db"
import { v4 as uuidv4 } from "uuid"

// Write a function called importProject that receives a JSON
// formatted string and saves it to the database, returning the id.
export const importProject = async (b: TextAnalyticsPlusDexie, project: string) => {
    const data = JSON.parse(project) as Project
    data.createdAt = Date.now()
    data.uuid = uuidv4()
    const id = await b.projects.add(data)
    return id
}
